import React from 'react';
import './Loader.css';

/**
 * EventGraphia's loader: the app's own mark over a hairline indeterminate bar.
 *
 * `logoSrc` comes from the host app, which owns its branding: EG and WG ship
 * different marks, and the professional app ships its own file. Without one
 * the bar and the label stand alone.
 *
 * `inline` drops the full page overlay, for a panel waiting on its own content
 * rather than the whole page.
 */
const Loader = ({ logoSrc, inline, label = 'Loading' }) =>
  React.createElement(
    'div',
    { className: inline ? 'eg-loader-inline' : 'eg-loader-overlay' },
    React.createElement(
      'div',
      { className: 'eg-loader', role: 'status', 'aria-live': 'polite', 'aria-busy': 'true' },
      logoSrc
        ? React.createElement('img', {
          className: 'eg-loader__logo',
          src: logoSrc,
          alt: '',
        })
        : null,
      React.createElement(
        'div',
        { className: 'eg-loader__track' },
        React.createElement('div', { className: 'eg-loader__bar' })
      ),
      React.createElement('span', { className: 'eg-loader__label' }, label)
    )
  );

export default Loader;
